// ─────────────────────────────────────────────────────────────
// SBA — /replay page configuration
// ─────────────────────────────────────────────────────────────

export const REPLAY_CONFIG = {
  // Empty → replay is always available.
  REPLAY_VIDEO_URL: "https://youtu.be/y5Xyr_Hgdso",

  // Empty string means "no availability window shown."
  REPLAY_WINDOW_OR_EXPIRY_DATE: "",

  // Empty string means replay never expires.
  REPLAY_EXPIRES_AT: "",

  // Default is the SBA discovery-call calendar (same as the main site).
  GHL_CALENDAR_EMBED_URL:
    "https://link.smallbusinessautomator.com/widget/booking/WGbRNaPia1Cil2uRYo8Q",

  WEBINAR_TITLE: "The Webinar Acquisition Method (The WAM)",

  WEBINAR_PROMISE: "Stop renting your pipeline. Start owning it.",

  // Not used — capacity phrase omitted per SBA direction.
  REAL_CAPACITY: "",

  // A2P 10DLC compliant messaging disclosure. Full policies live at
  // /privacy, /terms, /disclaimer.
  APPROVED_COMPLIANCE_COPY:
    "By providing your phone number, you agree to receive SMS messages from Small Business Automator regarding appointments, follow-ups, and services you've requested. Message frequency varies. Message and data rates may apply. Reply HELP for help. Reply STOP to opt out. Mobile information and opt-in consent will not be shared with third parties or affiliates for marketing or promotional purposes. See our Privacy Policy, Terms, and Disclaimer for details.",

  // Approved testimonials mirror the main WAM page (Proof section).
  VERIFIED_PERMISSIONED_TESTIMONIALS_ONLY: [
    {
      name: "Marcus Hayes",
      company: "MLO · FHA + First-Time Buyer",
      quote:
        "First webinar produced 34 registrants in a week. Two of them closed in 60 days. My CRM finally does the follow-up for me.",
    },
    {
      name: "Priya Shah",
      company: "Broker Owner · DSCR Investor Niche",
      quote:
        "I stopped chasing realtors. Now investors book applications directly from the replay page. Cleanest pipeline of my career.",
    },
    {
      name: "Jordan Lee",
      company: "Loan Officer · VA / Military Bases",
      quote:
        "The webinar script + niche framing changed everything. My close rate on booked calls doubled because they show up educated.",
    },
  ],

  META_DESCRIPTION: "",
};

export function isReplayActive(cfg = REPLAY_CONFIG) {
  const iso = cfg.REPLAY_EXPIRES_AT;
  if (!iso) return true;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return true;
  return Date.now() < t;
}

export function hasApprovedTestimonials(cfg = REPLAY_CONFIG) {
  return (
    Array.isArray(cfg.VERIFIED_PERMISSIONED_TESTIMONIALS_ONLY) &&
    cfg.VERIFIED_PERMISSIONED_TESTIMONIALS_ONLY.length > 0
  );
}
